import { EventDispatcher } from '@js/utils/toolbox';


/**
 * Formats a price based on formatting options
 * @param {number} price - The price to format
 * @param {Object} formating - Formatting options (falls back to global settings)
 * @returns {string} Formatted price string
 */
export function lc (price, formating) {
	if (typeof formating === 'undefined' || formating === true) {
		formating = {};
	}

	// Merge with default formatting options
	for (const key in globalThis.js_params.defaultCurrencyFormating) {
		if (!formating.hasOwnProperty(key)) {
			formating[key] = globalThis.js_params.defaultCurrencyFormating[key];
		}
	}

	price = Number(price).toFixed(formating.decimals);

	// Apply decimal symbol
	if (formating.decimalSymbol !== '.') {
		price = price.replace('.', formating.decimalSymbol);
	}

	// Add thousand separators
	price = price.toString().replace(
		/(\d)(?=(\d{3})+(?!\d))/g,
		'$1' + formating.thousandSeperator
	);

	// Format currency symbol position
	const preString = formating.symbolPositionBefore
		? formating.symbol + (formating.symbolSpace ? ' ' : '')
		: '';
	const postString = !formating.symbolPositionBefore
		? (formating.symbolSpace ? ' ' : '') + formating.symbol
		: '';

	return preString + price + postString;
}

/**
 * Get the translated text for the specified translation key
 * @param {string} key - The translation key
 * @param {string} str - Fallback string
 * @returns {string} Translated text or fallback
 */
export function l (key, str = '') {
	if (globalThis.js_localized[key]) {
		return globalThis.js_localized[key];
	}

	if (globalThis.js_params.debug) {
		EventDispatcher.dispatch('translation.missingKey', key);
	}

	if (typeof globalThis.localizationMissing === 'undefined') {
		globalThis.localizationMissing = {};
	}

	globalThis.localizationMissing[key] = 1;

	return str || key;
}

/**
 * Get translated text with variable replacement
 * @param {string} lkey - The translation key
 * @param {Object} dictionary - Variables to insert
 * @returns {string} Translated text with variables replaced
 */
export function lreplace (lkey, dictionary) {
	let text = l(lkey);

	for (const key in dictionary) {
		if (!dictionary.hasOwnProperty(key)) {
			continue;
		}
		text = text.replace(new RegExp('\\$' + key, 'g'), dictionary[key]);
	}

	return text;
}

/**
 * Get localized file path
 * @param {string} path - Path to file
 * @param {boolean} versionControl - Whether to prepend version number
 * @returns {string} Localized file path
 */
export function lm (path, versionControl = true) {
	path = path.split('/');
	const filename = globalThis.js_params.language + '_' + path.pop();

	return (
		(versionControl ? '/static/v' + globalThis.js_params.version : '')
		+ path.join('/')
		+ '/'
		+ filename
	);
}

/**
 * Generate a localized link slug
 * @param {string} key - Translation key
 * @param {boolean} prefixLanguage - Whether to prefix with language code
 * @returns {string} Localized link
 */
export function lLink (key, prefixLanguage = true) {
	const link = l(key).toLowerCase().replace(/[\s_]/g, '-');

	if (prefixLanguage && globalThis.js_params.language !== globalThis.js_params.defaultLanguage) {
		const language = globalThis.js_params.language;
		const url = globalThis.location.pathname.split('/');
		if (url?.[1] === language) {
			return language + '/' + link;
		}
	}

	return link;
}

/**
 * Override translation functions with debug tokens
 */
export function overrideTranslationFunctions () {
	l = key => `⟦i18n:${key}⟧`;
	lm = (key, count) => `⟦i18n:${key}⟧`;
	lreplace = (key, replace) => `⟦i18n:${key}⟧`;
}
